<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('notification_overview.page_title') }}</slot>
            <slot slot="description">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/notifications/create">{{ $t('notification_overview.create') }}</router-link>
            </slot>
        </page-header>

        <v-overview-list
            prefix="a1"
            data-table="AllNotifications"
            data-pagination="NotificationsPagination"
            btnViewPath="NotificationsEdit"
            :table-columns="Columns"
            :page-size="12">

            <template slot="placeholderButtonsFooter">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/notifications/create">{{ $t('notification_overview.create') }}</router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            Columns() {
                return [
                  {
                      value: 'Title',
                      name: this.$t('notification_overview.columns.title'),
                      sortable: false
                  },
                  {
                      value: 'BranchString',
                      name: this.$t('notification_overview.columns.branches'),
                      sortable: false
                  },
                  {
                      value: 'StartDate',
                      name: this.$t('notification_overview.columns.start_date'),
                      sortable: false,
                      type:'Date'
                  },
                  {
                      value: 'EndDate',
                      name: this.$t('notification_overview.columns.end_date'),
                      sortable: false,
                      type:'Date'
                  }
              ];
            }
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/notification/Overview.vue